import { ChakraV3, FloatingPopover, NumberedBadge } from '@piccolohealth/ui';
import React from 'react';
import { FaCaretDown, FaFilter } from 'react-icons/fa';

import { FormStack } from '../../components/forms/FormStack';
import type { AuditTrailFilter } from '../../hooks/useAuditTrailFilter';
import { AuditTrailDateFilterControl } from './AuditTrailDateFilterControl';
import { AuditTrailEventFilterControl } from './AuditTrailEventFilterControl';
import { AuditTrailMessageFilterControl } from './AuditTrailMessageFilterControl';
import { AuditTrailUserFilterControl } from './AuditTrailUserFilterControl';

interface Props {
  filter: AuditTrailFilter;
}

export const AuditTrailFilterControls = (props: Props) => {
  const { filter } = props;

  return (
    <FormStack orientation='horizontal'>
      <ChakraV3.Stack maxW='xs'>
        <AuditTrailMessageFilterControl filter={filter} />
      </ChakraV3.Stack>
      <FloatingPopover
        render={() => (
          <ChakraV3.Stack bg='white' gap={0} w='xs' shadow='2xl' rounded='md'>
            <ChakraV3.HStack py={2} px={4} borderBottomWidth='1px'>
              <ChakraV3.Text fontWeight='semibold'>Filters</ChakraV3.Text>
              <ChakraV3.Spacer />
              <NumberedBadge count={props.filter.activeFilterCount} />
            </ChakraV3.HStack>
            <FormStack py={4} px={4} orientation='vertical'>
              <ChakraV3.FormField label='Date'>
                <AuditTrailDateFilterControl filter={filter} />
              </ChakraV3.FormField>

              <ChakraV3.FormField label='Event'>
                <AuditTrailEventFilterControl filter={filter} />
              </ChakraV3.FormField>

              <ChakraV3.FormField label='User'>
                <AuditTrailUserFilterControl filter={filter} />
              </ChakraV3.FormField>

              <ChakraV3.Button
                w='fit-content'
                size='sm'
                variant='outline'
                colorPalette='brand'
                disabled={props.filter.activeFilterCount === 0}
                onClick={props.filter.reset}
              >
                Reset
              </ChakraV3.Button>
            </FormStack>
          </ChakraV3.Stack>
        )}
      >
        <ChakraV3.Button size='sm' variant='outline' lineHeight='unset'>
          <FaFilter />
          <ChakraV3.HStack>
            Filter
            <ChakraV3.Stack w='28px'>
              <NumberedBadge count={props.filter.activeFilterCount} />
            </ChakraV3.Stack>
          </ChakraV3.HStack>
          <FaCaretDown />
        </ChakraV3.Button>
      </FloatingPopover>
    </FormStack>
  );
};
